import { hideLoading, showLoading } from 'react-redux-loading-bar';
import api from '../../utils/api';

const ActionType = {
  UP_VOTE_COMMENT: 'UP_VOTE_COMMENT',
  DOWN_VOTE_COMMENT: 'DOWN_VOTE_COMMENT',
  NEUTRALIZE_VOTE_COMMENT: 'NEUTRALIZE_VOTE_COMMENT',
};

const upVoteCommentActionCreator = (vote) => ({
  type: ActionType.UP_VOTE_COMMENT,
  payload: {
    vote,
  },
});

const downVoteCommentActionCreator = (vote) => ({
  type: ActionType.DOWN_VOTE_COMMENT,
  payload: {
    vote,
  },
});

const neutralizeVoteCommentActionCreator = (vote) => ({
  type: ActionType.NEUTRALIZE_VOTE_COMMENT,
  payload: {
    vote,
  },
});

const asyncUpVoteComment = ({ threadId, commentId }) => async (dispatch) => {
  dispatch(showLoading());
  try {
    const vote = await api.UpVoteComment(threadId, commentId);
    dispatch(upVoteCommentActionCreator(vote));
  } catch (error) {
    alert(error.message);
  }
  dispatch(hideLoading());
};

const asyncDownVoteComment = ({ threadId, commentId }) => async (dispatch) => {
  dispatch(showLoading());
  try {
    const vote = await api.downVoteComment(threadId, commentId);
    dispatch(upVoteCommentActionCreator(vote));
  } catch (error) {
    alert(error.message);
  }
  dispatch(hideLoading());
};

const asyncNeutralizeVoteComment = ({ threadId, commentId }) => async (dispatch) => {
  dispatch(showLoading());
  try {
    const vote = await api.neutralizeVoteThread(threadId, commentId);
    dispatch(neutralizeVoteCommentActionCreator(vote));
  } catch (error) {
    alert(error.message);
  }
  dispatch(hideLoading());
};

export {
  ActionType,
  upVoteCommentActionCreator,
  downVoteCommentActionCreator,
  neutralizeVoteCommentActionCreator,
  asyncUpVoteComment,
  asyncNeutralizeVoteComment,
  asyncDownVoteComment,
};
